<!-- 任务数据明细 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="时间段：">
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="任务名称：">
        <el-input placeholder="输入任务名称" @change="getTableList()" v-model="params.taskTitle"></el-input>
      </el-form-item>
       <el-form-item label="完成状态：">
        <el-select v-model="params.status">
          <el-option value="" label="全部"></el-option>
          <el-option value="0" label="未完成"></el-option>
          <el-option value="1" label="已完成"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属游戏：">
        <el-select v-model="params.outGameId">
          <el-option value="" label="全部"></el-option>
          <el-option v-for="item in gamesData" :key="item.outGameId" :value="item.outGameId" :label="item.gameName"></el-option>
        </el-select>
      </el-form-item><el-form-item label="网关名称：">
        <el-input placeholder="输入网关名称" @change="getTableList()" v-model="params.netBarAccount"></el-input>
      </el-form-item>
      <el-form-item label="用户ID：">
        <el-input placeholder="输入用户ID" @change="getTableList()" v-model="params.userId"></el-input>
      </el-form-item>
      <el-form-item label="领取状态：">
        <el-select v-model="params.rewardStatus">
          <el-option value="" label="全部"></el-option>
          <el-option value="0" label="未领取"></el-option>
          <el-option value="1" label="已领取"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
        <!-- <el-button size="small" type="primary">导出</el-button> -->
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="日期" prop="updateTime"></el-table-column>
      <el-table-column label="用户ID" prop="userId"></el-table-column>
      <el-table-column label="使用时长" prop="userTimes"></el-table-column>
      <el-table-column label="所属游戏" prop="gameName"></el-table-column>
      <el-table-column label="网关账号" prop="netBarAccount"></el-table-column>
      <el-table-column label="任务名称" prop="taskTitle"></el-table-column>
      <el-table-column label="完成状态" prop="taskStatus">
        <template slot-scope="scope">{{ scope.row.taskStatus|taskStatusFilters }}</template>
      </el-table-column>
      <el-table-column label="领取状态" prop="rewardStatus">
        <template slot-scope="scope">{{ scope.row.rewardStatus|rewardStatusFilters }}</template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>
  </div>
</template>
 
<script>
  export default {
    data() {
      //这里存放数据
      return {
        time:'',
        params:{
          taskId:'',
          outGameId:'',
          taskTitle: '',
          netBarAccount: '',
          userId: '',
          startTime: '',
          endTime: '',
          status: '',
          rewardStatus: '',
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        tableData:[],
        gamesData:[]
      };
    },
    filters:{
      // 1 未完成，2 未领取，3 已领取，4-奖励限量且已抢光，5，用户限量
      taskStatusFilters(status){
        switch (status) {
          case 1:
            return '未完成';
          default:
            return '已完成';
        }
      },
      rewardStatusFilters(status){
        switch (status) {
          case 0:
            return '未领取';
          case 1:
            return '领取中';
          case 2:
            return '领取成功';
          case 3:
            return '领取失败';
          default:
            return '未领取';
        }
      }
    },
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.taskRecords.getTaskRecordDetail,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      /**获取游戏数据 */
      getGameList(){
        this.ajax.fetch({
          url: this.apis.taskRecords.getOutGameSelected,
          disableLoading: true,
          method: 'post',
          successFunc: res=>{
            this.gamesData = res;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      dateChange(value) {
        this.params.startTime = value[0];
        this.params.endTime = value[1];
      },
      resetParams(){
        this.params={
          taskId:'',
          outGameId:'',
          taskTitle: '',
          netBarAccount: '',
          userId: '',
          startTime: '',
          endTime: '',
          status: '',
          rewardStatus: '',
          pageNum: 1,
          pageSize: 10
        }
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.params.taskId = this.$route.query.taskId ? this.$route.query.taskId : '';
      if (this.$route.query.userId)  this.params.userId = this.$route.query.userId;
      this.getTableList();
      this.getGameList();
    },
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/activityManage/taskDataDetails/taskDataDetails.vue